import SYSTEM_CONSTANTS from "common/constants";
import HttpClient from "./http-client";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AjaxError } from "rxjs/ajax";
import { IComboTourParams } from "common/define-types";
import Utils from "common/Utils";

//[14-12-2023][Phuc Thinh][Feature/14901]
// add API get combo tours
const api = `${SYSTEM_CONSTANTS.API_URL}/ComboTour`;

export const getAllComboTours = (params: IComboTourParams): Observable<any> => {
  return HttpClient.get(`${api}?${Utils.getParamsString(params)}`).pipe(
    map(
      (res) => (res as any) || null,
      catchError((e: AjaxError) => throwError(e))
    )
  );
};
